/**
 * Finds the active menu item based on page ID
 */

/**
 * Get page id from meta tag
 * @returns {string|null} Page id from meta tag
 */
export function getPageId() {
  const pageIdMetaTag = document.querySelector('meta[name="PageID"]');
  return pageIdMetaTag ? pageIdMetaTag.getAttribute('content') : null;
}

/** 
 * Get active menu item based on PageID meta tag
 * 
 * @param {Element} container The ul menu container element
 * @param {string} menuSelector CSS selector for the ul menu (e.g., '[data-drilldown]' or '[data-accordion-menu]')
 * @param {string|null} pageId Optional page ID. If not provided, will be retrieved from meta tag
 * @returns {Array|null} Array with [activeMenuContainer, activeMenu, activeLink] or null if not found
 */
export function getActiveMenuItem(container, menuSelector = '[data-drilldown]', pageId = null) {
  // Get pageId if not provided
  const currentPageId = pageId || getPageId();
  
  if (!currentPageId) {
    return null;
  }
  
  // Find all anchor links with matching data-asset-id
  const matchingLinks = container.querySelectorAll(`a[data-asset-id="${currentPageId}"]`);

  if (matchingLinks.length === 0) {
    return null;
  }
  
  if (matchingLinks.length !== 1) {
    console.warn(`${matchingLinks.length} menu items with same data-asset-id found; 1 expected.`);
  }

  // Use first matching link
  const activeLink = matchingLinks[0];
  const activeMenu = activeLink.closest('ul');
  const activeMenuContainer = activeMenu ? activeMenu.closest(menuSelector) : null;
  return [activeMenuContainer, activeMenu, activeLink];
}
